import * as arrayHelpers from './array';
import * as localStorageHelpers from './local-storage';
import * as toothNumberHelpers from './tooth-numbers';
import * as mixed from './mixed';

const Helper = {
    ...arrayHelpers,
    ...localStorageHelpers,
    ...toothNumberHelpers,
    ...mixed,
};
window.Helper = Helper;

export default Helper;
